import React from "react";

export default function ValidatePatientAction({ validating, error, onValidate, label = "Valider patient" }) {
    return (
        <>
            {error && (
                <span role="alert" style={{ color: "#b91c1c", fontSize: "13px", fontWeight: 600 }}>
                    {error}
                </span>
            )}
            <button
                onClick={onValidate}
                disabled={validating}
                style={{
                    padding: "10px 16px",
                    borderRadius: "8px",
                    border: "none",
                    background: "#16a34a",
                    color: "white",
                    cursor: validating ? "default" : "pointer",
                    fontSize: "14px",
                    fontWeight: 600,
                    opacity: validating ? 0.7 : 1,
                    display: "inline-flex", alignItems: "center", gap: "8px",
                    transition: "background 0.15s",
                }}
                onMouseEnter={e => { if (!validating) e.currentTarget.style.background = "#15803d"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "#16a34a"; }}
            >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12"/>
                </svg>
                {validating ? "Validation..." : label}
            </button>
        </>
    );
}
